import React from "react";

//style
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@material-ui/icons/Email";
import loginPageStyle from "./../../assets/jss/material-kit-react/views/loginPage.jsx";

//components
import Header from "./../Header/Header.jsx";
import HeaderLinks from "./../Header/HeaderLinks.jsx";

import GridContainer from "./../elements/Grid/GridContainer.jsx";
import GridItem from "./../elements/Grid/GridItem.jsx";
import Button from "./../elements/CustomButtons/Button.jsx";
import Card from "./../elements/Card/Card.jsx";
import CardBody from "./../elements/Card/CardBody.jsx";
import CardHeader from "./../elements/Card/CardHeader.jsx";
import CardFooter from "./../elements/Card/CardFooter.jsx";
import CustomInput from "./../elements/CustomInput/CustomInput.jsx";

// redux
import { login } from "./../../actions/user";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardAnimaton: "cardHidden"
        };
        this.state = {
            email: "",
            pass: ""
        };
    }
    handleChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };
    handleClickLogin = e => {
        e.preventDefault();
        this.props.login({
            username: this.state.email,
            passwordHash: this.state.pass
        });
        // this.props.login({
        //     username: this.state.username,
        //     passwordHash: sha256(this.state.password)
        // });
    };
    componentDidMount() {
        setTimeout(
            function() {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    render() {
        // console.log(this.props);
        const { classes, ...rest } = this.props;
        return (
            <div>
                <Header
                    absolute
                    color="transparent"
                    brand="Admin panel for Soroban"
                    rightLinks={<HeaderLinks />}
                    {...rest}
                />
                <div
                    className={classes.pageHeader}
                    style={{
                        backgroundImage: `url('data:image/svg+xml,<svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" width%3D"1440" height%3D"389" viewBox%3D"0 0 1440 389">  <defs>    <linearGradient id%3D"a" x1%3D"122.39%25" x2%3D"2.34%25" y1%3D"-75.02%25" y2%3D"100%25">      <stop offset%3D"0%25" stop-color%3D"%23FBCE00" stop-opacity%3D".06"%2F>      <stop offset%3D"100%25" stop-color%3D"%233433A8"%2F>    <%2FlinearGradient>    <linearGradient id%3D"b" x1%3D"93.77%25" x2%3D"0%25" y1%3D"-58.21%25" y2%3D"107.1%25">      <stop offset%3D"0%25" stop-color%3D"%2329B9CE"%2F>      <stop offset%3D"100%25" stop-color%3D"%23008A4F"%2F>    <%2FlinearGradient>    <linearGradient id%3D"c" x1%3D"100%25" x2%3D"3.99%25" y1%3D"50%25" y2%3D"0%25">      <stop offset%3D"0%25" stop-color%3D"%23FF9B00"%2F>      <stop offset%3D"100%25" stop-color%3D"%23EBA9A9"%2F>    <%2FlinearGradient>    <linearGradient id%3D"d" x1%3D"81.85%25" x2%3D"2.59%25" y1%3D"-36.34%25" y2%3D"64.64%25">      <stop offset%3D"0%25" stop-color%3D"%235900FF"%2F>      <stop offset%3D"100%25" stop-color%3D"%2303C57F"%2F>    <%2FlinearGradient>    <linearGradient id%3D"e" x1%3D"99.99%25" x2%3D"-22.92%25" y1%3D"-35.25%25" y2%3D"82.12%25">      <stop offset%3D"0%25" stop-color%3D"%23FF915E"%2F>      <stop offset%3D"33.54%25" stop-color%3D"%23FF905E"%2F>      <stop offset%3D"100%25" stop-color%3D"%23F95475"%2F>    <%2FlinearGradient>  <%2Fdefs>  <g fill%3D"none" fill-rule%3D"evenodd" opacity%3D".82">    <path fill%3D"url(%23a)" d%3D"M0 367.07c230.4-239.7 470.4-304.02 720-192.93 301.48 134.18 541.48 117.84 720-49.01v17.4c-211.89 204.18-451.89 245.92-720 125.2-268.11-120.7-508.11-81.96-720 116.24v-16.9z" opacity%3D".64" transform%3D"matrix(-1 0 0 1 1440 0)"%2F>    <path fill%3D"url(%23b)" d%3D"M0 211c81.6 63.1 321.26 16.74 718.97-139.06 259.71-101.74 499.37-95.57 718.97 18.51v170.96c-175.04-139.44-415.04-186.75-720-141.94-168 24.68-407.31 97.98-717.94 219.9V211z" opacity%3D".56"%2F>    <path fill%3D"url(%23c)" d%3D"M0 328.57C458.74 89.09 824.57 14.6 1097.49 105.13c168.93 56.02 283.1 73.17 342.51 51.43v10.28c-194.06 215.77-434.06 258.17-720 127.2-226.63-103.8-466.63-89.4-720 43.2v-8.67z" opacity%3D".59"%2F>    <path fill%3D"url(%23d)" d%3D"M0 330.37C120.69 52.95 361.71-29.07 723.09 84.32c361.37 113.38 600.34 113.38 716.91 0v17.4C1152.69 297.26 912.69 345.85 720 247.5 508.36 139.47 268.36 169.98 0 339.04v-8.67z"%2F>    <path fill%3D"url(%23e)" d%3D"M0 91.33c141.46 125.49 381.46 119.32 720-18.51 252.78-102.91 492.78-96.74 720 18.51V388.8c-176.48-223.68-416.82-312.9-721.03-267.64C547.07 146.73 307.41 219.76 0 340.25V91.33z"%2F>  <%2Fg><%2Fsvg>')`,
                        backgroundSize: "cover",
                        backgroundPosition: "top center"
                    }}
                >
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={4}>
                                <Card className={classes[this.state.cardAnimaton]}>
                                    <form className={classes.form}>
                                        <CardHeader color="primary" className={classes.cardHeader}>
                                            <h4>Вход</h4>
                                        </CardHeader>
                                        <CardBody>
                                            <CustomInput
                                                labelText="Email..."
                                                id="email"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    type: "email",
                                                    onChange: this.handleChange,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <Email className={classes.inputIconsColor} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                            <CustomInput
                                                labelText="Пароль"
                                                id="pass"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    type: "password",
                                                    onChange: this.handleChange,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <Icon className={classes.inputIconsColor}>
                                                                lock_outline
                                                            </Icon>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </CardBody>
                                        <CardFooter onClick={this.handleClickLogin} className={classes.cardFooter}>
                                            <Button simple color="primary" size="lg">
                                                Войти
                                            </Button>
                                        </CardFooter>
                                    </form>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
        );
    }
}

const widthConnect = connect(
    state => ({ user: state.user.user }),
    dispatch => bindActionCreators({ login }, dispatch)
);

export default withStyles(loginPageStyle)(widthConnect(LoginPage));
